import { useEffect, useState } from "react";

const useInView = (elementId, options = {}) => {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const element = document.getElementById(elementId);
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      options
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [elementId, options]);

  return inView;
};

export default useInView;
